import { React, useState, useEffect, useRef } from 'react';
import Step from '../Step';
import ColorPicker from '../ColorPicker';
import Slider from '../Slider';
import './index.scss';
import Loader from '../Loader';
import Modal from '../Modal';
import Shapes from '../Shapes';
import printHeader from '../../Assets/Images/impresion.png';

const Scenary = ({ user, step, setStep }) => {
  const [savedSteps, setSavedSteps] = useState([]);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const [showShapes, setShowShapes] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showFinish, setShowFinish] = useState(false);
  const [brushColor, setBrushColor] = useState('#000000');
  const [brushRadius, setBrushRadius] = useState(1);
  const [brushShape, setBrushShape] = useState('pencil');
  const [eraser, setEraser] = useState('pencil');
  const textArea = useRef(null);
  const [texts, setTexts] = useState(['', '', '', '', '', '']);
  const step1 = useRef();
  const step2 = useRef();
  const step3 = useRef();
  const step4 = useRef();
  const step5 = useRef();
  const step6 = useRef();
  const [timestamp] = useState(Date.now());

  useEffect(() => {
    setBrushColor('#000000');
    setBrushRadius(1);
    setBrushShape('pencil');
    setEraser(false);
  }, [step]);

  if (step === 0) {
    return null;
  }

  const onClickPencil = (event) => {
    event.preventDefault();

    setEraser(false);
    setBrushShape('pencil');
  };

  const onClickSlider = (event) => {
    event.preventDefault();

    setShowSlider(true);
  };

  const onClickColors = (event) => {
    event.preventDefault();

    setEraser(false);
    setShowColorPicker(true);
  };

  const onClickEraser = (event) => {
    event.preventDefault();

    setEraser(true);
    setBrushShape('rectangle');
    setTimeout(() => {
      setBrushShape('pencil');
    }, 200);
  };

  const onClickShape = (event) => {
    event.preventDefault();

    setEraser(false);
    setShowShapes(true);
  };

  const onChangeColorPicker = (color) => {
    setBrushColor(color.hex);
  };

  const onChangeSlider = (radius) => {
    setBrushRadius(radius);
    const actualBrushShape = brushShape;
    setBrushShape('rectangle');
    setTimeout(() => {
      setBrushShape(actualBrushShape);
    }, 200);
  };

  const onChangeShapes = (shape) => {
    setBrushShape(shape);
  };

  const onInputTextArea = (event) => {
    const textsValues = texts;
    textsValues[step - 1] = event.target.value;
    setTexts(textsValues);
  };

  const onClickLink = (event) => {
    event.preventDefault();

    const newStep = parseInt(event.target.dataset.step);
    texts[step - 1] = textArea.current.value;
    setStep(newStep);
    textArea.current.value = texts[newStep - 1];
  };

  const onClickNext = (event) => {
    event.preventDefault();

    const newStep = step + 1;
    if (newStep > 6) {
      setShowHelp(false);
      setShowFinish(true);
    } else {
      texts[step - 1] = textArea.current.value;
      setStep(newStep);
      textArea.current.value = texts[newStep - 1];
      setShowHelp(false);

      savedSteps.push(step);
      const uniqueSavedSteps = [...new Set(savedSteps)];
      setSavedSteps(uniqueSavedSteps);
    }
  };

  const onClickRestart = (event) => {
    event.preventDefault();

    window.location.reload();
  };

  const onClickFinish = (event) => {
    event.preventDefault();

    setShowFinish(true);
  };

  const onClickSave = (event) => {
    event.preventDefault();

    setShowLoader(true);

    const saveImage = (saveData) => {
      const userData = user.split('-');

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${window.access_token}`,
        },
        body: JSON.stringify({
          base64: saveData,
          step: step,
          text: texts[step - 1],
          name: userData[1],
          surname: userData[2],
          classroom: userData[3],
          filename: `${userData[4]}_${step}_${timestamp}.png`,
          timestamp,
          school_code: userData[0],
        }),
      };

      fetch(`${window.location.origin}/image_save`, requestOptions)
        .then((response) => {
          if (!response.ok) throw Error(response.message);

          return response.json();
        })
        .then((data) => {
          setShowLoader(false);
          setShowHelp(true);
        })
        .catch((error) => {
          alert(error);
          setShowLoader(false);
        });
    };

    let stepRef = '';
    if (step === 1) {
      stepRef = step1;
    }
    if (step === 2) {
      stepRef = step2;
    }
    if (step === 3) {
      stepRef = step3;
    }
    if (step === 4) {
      stepRef = step4;
    }
    if (step === 5) {
      stepRef = step5;
    }
    if (step === 6) {
      stepRef = step6;
    }

    stepRef.current.setBackgroundFromDataUrl(
      printHeader,
      {
        stretchedX: true,
        originX: 0,
        originY: 0,
      },
      () => {
        const base64 = stepRef.current.toDataURL();
        stepRef.current.removeBackgroundImage();
        saveImage(base64);
      }
    );
  };

  return (
    <>
      <div className='scenary'>
        <div>
          <div className='scenary__label'>Página {step}. Dibujo</div>
          <div className='scenary__step'>
            <Step step={1} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step1} />
            <Step step={2} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step2} />
            <Step step={3} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step3} />
            <Step step={4} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step4} />
            <Step step={5} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step5} />
            <Step step={6} currentStep={step} brushColor={brushColor} brushRadius={brushRadius} brushShape={brushShape} eraser={eraser} ref={step6} />
          </div>
          <div className='scenary__label'>Escribe el texto que acompaña a tu dibujo</div>
          <textarea className='scenary__textarea' onInput={onInputTextArea} ref={textArea}></textarea>
        </div>
        <div className='scenary__tools'>
          <div>
            <div className='scenary__list'>
              <div className='scenary__list-title'>Página {step} de 6</div>
              <ul className='scenary__list-ul'>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='1' onClick={onClickLink}>
                    Página 1
                  </button>
                </li>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='2' onClick={onClickLink}>
                    Página 2
                  </button>
                </li>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='3' onClick={onClickLink}>
                    Página 3
                  </button>
                </li>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='4' onClick={onClickLink}>
                    Página 4
                  </button>
                </li>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='5' onClick={onClickLink}>
                    Página 5
                  </button>
                </li>
                <li className='scenary__list-item'>
                  <button className='scenary__list-link' data-step='6' onClick={onClickLink}>
                    Página 6
                  </button>
                </li>
              </ul>
            </div>
            <div className='scenary__buttons'>
              <div className='scenary__button-container'>
                <button className='scenary__tool scenary__tool--pencil' onClick={onClickPencil}></button>
                <span className='scenary__tool-text scenary__tool-text--color1'>Dibujar</span>
              </div>
              <div className='scenary__button-container'>
                <button className='scenary__tool scenary__tool--size' onClick={onClickSlider}></button>
                <span className='scenary__tool-text scenary__tool-text--color2'>Grosor del trazo</span>
              </div>
              <div className='scenary__button-container'>
                <button className='scenary__tool scenary__tool--colors' onClick={onClickColors}></button>
                <span className='scenary__tool-text scenary__tool-text--color3'>Colorear</span>
              </div>
              <div className='scenary__button-container'>
                <button className='scenary__tool scenary__tool--eraser' onClick={onClickEraser}></button>
                <span className='scenary__tool-text scenary__tool-text--color4'>Borrar</span>
              </div>
              <div className='scenary__button-container'>
                <button className='scenary__tool scenary__tool--shapes' onClick={onClickShape}></button>
                <span className='scenary__tool-text scenary__tool-text--color5'>Formas</span>
              </div>
            </div>
          </div>
          <button className='button button--full button--small-text button--margin-top' onClick={onClickSave}>
            Guardar esta página
          </button>
          {savedSteps.indexOf(1) !== -1 && savedSteps.indexOf(2) !== -1 && savedSteps.indexOf(3) !== -1 && savedSteps.indexOf(4) !== -1 && (
            <button className='button button--full button--small-text button--margin-top' onClick={onClickFinish}>
              Finalizar mi historia
            </button>
          )}
        </div>
      </div>
      <ColorPicker color={brushColor} show={showColorPicker} setShow={setShowColorPicker} onChange={onChangeColorPicker} />
      <Slider radius={brushRadius} show={showSlider} setShow={setShowSlider} onChange={onChangeSlider} />
      <Shapes shape={brushShape} show={showShapes} setShow={setShowShapes} onChange={onChangeShapes} />
      <Loader show={showLoader} />
      {showHelp && (
        <Modal title='¡Guardado!'>
          <div className='help'>
            <div className='help__content'>
              <div className='help__text'>Página {step} guardada.</div>
              <button className='button button--no-margin-top' onClick={onClickNext} dangerouslySetInnerHTML={{ __html: step === 6 ? 'Terminar' : 'Pasa a la siguiente página &rarr;' }}></button>
              <div className='help__text'>Recuerda que siempre puedes volver a esta página desde el menú de la parte derecha.</div>
            </div>
          </div>
        </Modal>
      )}
      {showFinish && (
        <Modal title='¡Terminado!'>
          <div className='help'>
            <div className='help__content'>
              <div className='help__text'>¡Bien hecho! Ya has terminado. Ve a la galería para ver tu historia gráfica y la de otros concursantes.</div>
              <a rel='noopener noreferrer' href={window.gallery} className='button button--no-margin-top'>
                Ir a la galería
              </a>
              <button className='button button--no-margin-top' onClick={onClickRestart}>
                Volver a empezar
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Scenary;
